import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ClinicalNoteManifest, DocumentManifest } from '../types/aggregate-graph.types';

export interface ClinicalNoteDefinition {
	id: string;
	addNewLabel: string;
}

export interface CreateClinicalNoteResponse {
	clinicalNoteId: string;
	clinicalNoteManifest: ClinicalNoteManifest;
	documentInstanceId: string;
	documentManifest: DocumentManifest;
}

@Injectable({
	providedIn: 'root'
})
export class ClinicalNotesService {

	constructor(private httpClient: HttpClient) {
	}

	getCreatableClinicalNoteDefinitionsForVisit(id: string) {
		return this.httpClient.get<ClinicalNoteDefinition[]>(`/api/clinical-notes/types-for-visit/${id}`);
	}

	createClinicalNote(id: string, clinicalNoteDefinitionId: string) {
		return this.httpClient.post<CreateClinicalNoteResponse>('/api/clinical-notes', { visitId: id, clinicalNoteDefinitionId });
	}

	updateClinicalNoteName(clinicalNoteId: string, name: string) {
		return this.httpClient.put<void>(`/api/clinical-notes/${clinicalNoteId}/name`, JSON.stringify(name), { headers: { 'Content-Type': 'application/json' } });
	}

	exportClinicalNote(id: string, clinicalNoteVersion: number, documentInstanceVersion: number) {
		return this.httpClient.get(`/api/clinical-notes/${id}/pdf`, { observe: 'response', responseType: 'blob', params: { clinicalNoteVersion, documentInstanceVersion } });
	}

	unlockClinicalNote(clinicalNoteId: string, reason: string) {
		return this.httpClient.post<void>(`/api/clinical-notes/${clinicalNoteId}/unlocked`, JSON.stringify(reason), { headers: { 'Content-Type': 'application/json' } });
	}

	uploadAttachment(clinicalNoteId: string, attachmentId: string, file: File) {
		const formData = new FormData();
		formData.append('attachmentId', attachmentId);
		formData.append('attachment', file);
		return this.httpClient.post<void>(`/api/clinical-notes/${clinicalNoteId}/attachments`, formData, { reportProgress: true, observe: 'events' });
	}
}